module.exports = {
      id: "stories-usage",
      viewBox: "0 0 33 27.835",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#stories",
      toString: function () {
        return this.url;
      }
    }